import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Button from './Button';

function Tile(
    {
        icon,
        numberText,
        text,
        dangerouslySetText,
        className,
        onClick,
    }) {
    return (
        <Button
            className={className}
            variant='outlined'
            color='secondary'
            onClick={onClick}
        >
            <GridBlock
                direction='column'
                alignItems='center'
            >
                {icon}
                <Typography variant='h4'>
                    {numberText}
                </Typography>
                <Typography variant='h5' dangerouslySetInnerHTML={dangerouslySetText ? {__html: text} : undefined}>
                    {!dangerouslySetText ? text : null}
                </Typography>
            </GridBlock>
        </Button>
    )
}

Tile.propTypes = {
    classes: PropTypes.any,
    icon: PropTypes.object.isRequired,
    numberText: PropTypes.string,
    text: PropTypes.string,
}

Tile.defaultProps = {}

export default Tile;